import React from 'react';
import {makeStyles, Typography} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative'
    },
    label: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        color: theme.palette.text.primary
    },
    number: {
        fontSize: "3rem",
        //lineHeight: 1.6,
    },
    unit: {
        fontSize: "1rem",
        lineHeight: 1,
    },
    circle: {
        transition: "0.35s stroke-dashoffset",
        // axis compensation
        transform: "rotate(-90deg)",
        transformOrigin: "50% 50%",
        stroke: theme.palette.text.primary,
        fill: 'transparent',
    }
}));
const ProgressRing = (
    {
        number,
        unit,
        percent = 0,
        width = 120,
        borderWidth = 2,
    }
) => {

    const classes = useStyles();
    const center = (width / 2);
    const radius = center - (2 * borderWidth);
    const circumference = radius * 2 * Math.PI;

    const offset = circumference - (percent / 100 * circumference);

    return (
        <div className={classes.root}>
            <div className={classes.label}>
                <Typography className={classes.number} variant="subtitle1">
                    {number}
                </Typography>
                <Typography className={classes.unit} variant="subtitle2">
                    {unit}
                </Typography>
            </div>
            <svg
                className={classes.ring}
                width={width}
                height={width}>
                <circle
                    className={classes.circle}
                    strokeWidth={borderWidth}
                    r={radius}
                    cx={center}
                    cy={center}
                    strokeDasharray={`${circumference} ${circumference}`}
                    strokeDashoffset={offset}
                />

                <circle
                    className={classes.circle}
                    strokeWidth="1"
                    r={radius}
                    cx={center}
                    cy={center}/>

            </svg>
        </div>
    );
};

export default ProgressRing;